import styled, { css } from 'styled-components';

import CommonIcon from '../Icon';

export const buttonStyle = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;

  height: 40px;
  min-width: 40px;
  margin: 0;
  padding: 8px 24px;

  font-size: 16px;
  font-weight: 700;

  box-shadow: none;
  border-radius: 4px;
  background: transparent;
  border: 1.6px solid transparent;

  cursor: pointer;
`;

export const ButtonContent = styled.span<{ $isLoading?: boolean }>`
  white-space: nowrap;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
`;

export const Button = styled.button<{ $isLoading?: boolean }>`
  ${buttonStyle}

  &,
  * {
    outline: none;
  }

  /* Le bouton avec uniquement une icône n'a pas besoin de padding */
  &:has(span[role='img']:only-child) {
    padding: 0;
  }

  /* Le loader est plus petit sur le bouton  */
  [role='status'] {
    width: 25px;
    border-right-width: 4px;
  }
`;

export const LoaderContainer = styled.span`
  position: absolute;
  inset: 0;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InnerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;
  color: inherit;
`;

export const Icon = styled(CommonIcon)<{ $isLoading?: boolean }>`
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  text-decoration: none !important;
`;
